import { GeofencesEditPage, GeofencesRoute } from './-components';
import { createFileRoute } from '@tanstack/react-router';
import { generatePath } from '@/services/router/generate-path';

function GeofencesEditRoute() {
  return (
    <GeofencesRoute
      permission="journeys/geofences/edit"
      redirectTo={(params) =>
        generatePath('/workspaces/:workspaceId/geofences', { workspaceId: params.workspaceId ?? 0 })
      }
    >
      <GeofencesEditPage />
    </GeofencesRoute>
  );
}

export const Route = createFileRoute('/_authenticated/workspaces/$workspaceId/geofences/$geofenceId')({
  component: GeofencesEditRoute,
});
